module.exports = __webpack_public_path__ + "img/windshield_repair_and_replacement.e643333b.svg";